import { render, staticRenderFns } from "./SwabSampleAnalysisChart.vue?vue&type=template&id=493abff1&"
import script from "./SwabSampleAnalysisChart.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysisChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports